<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-31 10:08:55
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-28 13:16:04
 * @FilePath: /gamefi/components/Button/Copy.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <Button @click="onClick" :mode="mode" class="!p-1 m-auto flex items-center justify-center !w-[28px] !h-[28px]">
        <IconSvgUse use="icon-copy" class=" text-sm w-4 h-4 text-textFade" name="content_copy" />
        <slot />
    </Button>
</template>


<script lang="ts" setup>
import { copyToClipboard } from 'quasar'
import type { ButtonMode } from './index.vue';
import useTranslation from '~/i18n/useTransLation';

const props = defineProps({
    mode: {
        type: String as PropType<ButtonMode>,
        default: 'normal'
    },
    value: {
        type: [String, Number],
        default: '',
    },
});
const t = useTranslation();
const onClick = () => {
    let message = t.Copied;
    try{
        (document.activeElement as HTMLElement | null)?.blur?.();
        copyToClipboard(String(props.value))
            .then(() => {
                console.log('copied successful'); 
            })
            .catch((err) => {
                console.log('copied error', err); 
                message += '.'; // 开发人员监测标记 
            });
    }catch(err){
        message += '..'; // 开发人员监测标记 
        console.log('拷贝出错', err); 
    }
    showNegativeNotify({
        message,
        position: 'top',
        type: 'positive',
        timeout: 2_000,
    });
}


</script>